/** landing — EN source. */
export const landing = {
  // ---- Meta / SEO ----
  landing_meta_home_title: "Linqx — No Small Talk",
  landing_meta_home_description:
    "Match with people who share your vibe, explore your city together, and turn strangers into stories.",
  landing_meta_root_description:
    "Swipe less, live more. Match with people who share your vibe, explore your city together, and build real connections through shared experiences.",
  landing_meta_privacy_title: "Linqx — Privacy Policy",
  landing_meta_privacy_description:
    "Learn how Linqx collects, uses, and protects your personal information.",
  landing_meta_terms_title: "Linqx — Terms of Use",
  landing_meta_terms_description:
    "Read the terms and conditions for using the Linqx platform and services.",
  landing_meta_eula_title: "Linqx — End User License Agreement (EULA)",
  landing_meta_eula_description:
    "Read the End User License Agreement (EULA) for the Linqx mobile application.",

  // ---- Header / nav ----
  landing_nav_features: "Features",
  landing_nav_about: "About",
  landing_nav_join_waitlist: "Join Waitlist",
  landing_nav_toggle_menu: "Toggle menu",

  // ---- Hero ----
  landing_hero_eyebrow: "Swipe less. Live more.",
  landing_hero_title: "no small talk.",
  landing_hero_meet_prefix: "Meet people who love",
  landing_hero_rotating_adventure: "adventure",
  landing_hero_rotating_nightlife: "nightlife",
  landing_hero_rotating_coffee: "coffee dates",
  landing_hero_rotating_events: "live events",
  landing_hero_rotating_experiences: "new experiences",
  landing_hero_subtitle:
    "Linq up, share experiences in your city, and build a real connection with someone.",
  landing_hero_subtitle_emphasis: "Simple.",
  landing_hero_cta_match: "Match",
  landing_hero_cta_create_profile: "Create Your Profile",
  landing_hero_hint_mobile: "Swipe the cards 👇 ",
  landing_hero_hint_desktop: "Try the deck — drag a card 👉 ",
  landing_hero_hint_confirm: "Like who you meet? Confirm after you meet IRL.",
  landing_hero_scroll_indicator: "Scroll to explore",

  // ---- Swipe deck (a11y) ----
  landing_deck_pass_label: "Pass",
  landing_deck_link_label: "Link",
  landing_deck_stamp_link: "LINK",
  landing_deck_stamp_nope: "NOPE",

  // ---- Marquee band ----
  landing_marquee_no_small_talk: "No small talk",
  landing_marquee_real_connections: "Real connections",
  landing_marquee_meet_irl: "Meet IRL",
  landing_marquee_share_the_night: "Share the night",
  landing_marquee_adventure: "Adventure",
  landing_marquee_nightlife: "Nightlife",
  landing_marquee_coffee_dates: "Coffee dates",
  landing_marquee_live_music: "Live music",
  landing_marquee_city_explorers: "City explorers",

  // ---- Features section ----
  landing_features_title_prefix: "Find your ",
  landing_features_title_highlight: "vibe",
  landing_features_subtitle: "Choose experiences that match your energy.",
  landing_features_vibe_adventure: "Adventure",
  landing_features_vibe_lowkey: "Lowkey",
  landing_features_vibe_outdoor: "Outdoor",
  landing_features_vibe_indoor: "Indoor",
  landing_features_vibe_events: "Events",
  landing_features_vibe_nightlife: "Night Life",
  landing_features_vibe_foodie: "Foodie",
  landing_features_vibe_coffee: "Coffee",
  landing_features_vibe_art: "Art",
  landing_features_vibe_music: "Music",
  landing_features_vibe_sports: "Sports",
  landing_features_vibe_travel: "Travel",
  landing_features_card_match_title: "Match Authentically",
  landing_features_card_match_desc:
    "No algorithms, no games. Just real connections based on shared interests and experiences.",
  landing_features_card_experience_title: "Experience Together",
  landing_features_card_experience_desc:
    "Plan activities, explore your city, and create memories with someone new.",
  landing_features_card_build_title: "Build Connections",
  landing_features_card_build_desc:
    "Move beyond small talk and build meaningful relationships that last.",

  // ---- Flow showcase (how it works) ----
  landing_flow_badge: "How it works",
  landing_flow_title_prefix: "From hello to here, ",
  landing_flow_title_highlight: "one flow",
  landing_flow_subtitle:
    "Scroll through the Linqx journey — every tap, swipe and spark, the way it really happens.",
  landing_flow_keep_scrolling: "Keep scrolling",

  landing_flow_discover_eyebrow: "01 — Discover",
  landing_flow_discover_title: "Find your people",
  landing_flow_discover_desc:
    "Set your vibe and see who's actually around. Real people, near you, into the same things.",
  landing_flow_discover_action_vibe: "Pick your vibe",
  landing_flow_discover_action_nearby: "See who's nearby",
  landing_flow_discover_action_profile: "Your profile, ready",

  landing_flow_connect_eyebrow: "02 — Connect",
  landing_flow_connect_title: "Meet, then match",
  landing_flow_connect_desc:
    "Swipe straight to a real plan. Meet in person first — and only match once the spark is real.",
  landing_flow_connect_action_swipe: "Swipe to connect",
  landing_flow_connect_action_meet: "Pick a spot to meet",
  landing_flow_connect_action_match: "It's a Linq!",
  landing_flow_connect_action_chat: "Share contact & chat",

  landing_flow_live_eyebrow: "03 — Live",
  landing_flow_live_title: "Live the night",
  landing_flow_live_desc:
    "Turn a match into a night out — events near you, check-ins, and a little friendly competition.",
  landing_flow_live_action_events: "Discover events",
  landing_flow_live_action_checkin: "Check in, earn points",
  landing_flow_live_action_leaderboard: "Top the leaderboard",

  // ---- Flow phone screens (in-app demo) ----
  landing_screen_vibes_title: "Your vibe",
  landing_screen_vibes_subtitle: "What are you into?",
  landing_screen_vibes_continue: "Continue",
  landing_screen_vibe_adventure: "Adventure",
  landing_screen_vibe_nightlife: "Nightlife",
  landing_screen_vibe_coffee: "Coffee",
  landing_screen_vibe_live_music: "Live music",
  landing_screen_vibe_art: "Art",
  landing_screen_vibe_foodie: "Foodie",

  landing_screen_nearby_title: "Nearby",
  landing_screen_nearby_subtitle: "People around you right now",
  landing_screen_nearby_count: "{count} people",
  landing_screen_nearby_radius: "within {distance}",

  landing_screen_profile_name: "You, {age}",
  landing_screen_profile_tag_adventure: "Adventure",
  landing_screen_profile_tag_coffee: "Coffee",
  landing_screen_profile_tag_live_music: "Live music",
  landing_screen_profile_ready: "Profile ready",

  landing_screen_swipe_name: "{name}, {age}",
  landing_screen_swipe_distance: "1.2 km away",
  landing_screen_swipe_tag_coffee: "Coffee",
  landing_screen_swipe_tag_live_music: "Live music",
  landing_screen_swipe_tag_art: "Art",

  landing_screen_meet_title: "Pick a spot to meet",
  landing_screen_meet_subtitle: "Popular spots nearby",
  landing_screen_meet_suggest: "Suggest a place",
  landing_screen_spot_coffee_name: "Blue Bottle Coffee",
  landing_screen_spot_coffee_meta: "Coffee · 0.8 km",
  landing_screen_spot_bar_name: "The Rooftop Bar",
  landing_screen_spot_bar_meta: "Drinks · 1.4 km",
  landing_screen_spot_park_name: "Riverside Park",
  landing_screen_spot_park_meta: "Outdoors · 2.1 km",

  landing_screen_match_title: "It's a Linq!",
  landing_screen_match_pair: "You & {name}",
  landing_screen_match_met_irl: "You met in real life ✨",

  landing_screen_chat_contact_shared: "Contact shared",
  landing_screen_chat_msg_1: "Hey! That was so fun 👋",
  landing_screen_chat_msg_2: "Same! Same time next week?",
  landing_screen_chat_msg_3: "It's a date 💫",
  landing_screen_chat_placeholder: "Message…",

  landing_screen_events_title: "Tonight near you",
  landing_screen_events_subtitle: "Events your matches are into",
  landing_screen_event_location: "Downtown · 1.1 km",
  landing_screen_event_rooftop_name: "Rooftop Social",
  landing_screen_event_rooftop_meta: "Sat · 9:00 PM",
  landing_screen_event_rooftop_tag: "Going",
  landing_screen_event_vinyl_name: "Vinyl & Wine",
  landing_screen_event_vinyl_meta: "Fri · 8:00 PM",
  landing_screen_event_vinyl_tag: "+24 going",

  landing_screen_checkin_title: "Rooftop Social",
  landing_screen_checkin_subtitle: "You're here — check in",
  landing_screen_checkin_scan: "Scan to connect",
  landing_screen_checkin_button: "Check In",
  landing_screen_checkin_points: "+50 CP",
  landing_screen_checkin_countdown: "Speed Linq starts in 5:00",

  landing_screen_leaderboard_title: "Top Mixers",
  landing_screen_leaderboard_subtitle: "Rooftop Social · tonight",
  landing_screen_leaderboard_you: "You",
  landing_screen_leaderboard_footer: "You're #2 — keep mixing!",

  // ---- Stats section ----
  landing_stats_title_prefix: "Less app. ",
  landing_stats_title_highlight: "More you.",
  landing_stats_subtitle:
    "Linqx is built to get you off the screen and into the moment.",
  landing_stats_small_talk_label: "Lines of small talk",
  landing_stats_irl_label: "Meet in real life first",
  landing_stats_steps_suffix: " steps",
  landing_stats_steps_label: "From swipe to a real plan",
  landing_stats_vibes_label: "Vibes to match your energy",

  // ---- CTA section ----
  landing_cta_title_prefix: "Where connections ",
  landing_cta_title_highlight: "come to life",
  landing_cta_subtitle:
    "Swipe to match with someone new, then share an unforgettable experience together. From exclusive events to epic nights out — turn strangers into stories.",
  landing_cta_pillar_swipe: "Swipe",
  landing_cta_pillar_link: "Link",
  landing_cta_pillar_live: "Live",
  landing_cta_button: "Join the Waitlist",

  // ---- Waitlist form ----
  landing_waitlist_badge: "Limited Early Access",
  landing_waitlist_title_prefix: "Be part of something ",
  landing_waitlist_title_highlight: "special",
  landing_waitlist_subtitle: "Match. Experience. Connect.",
  landing_waitlist_name_placeholder: "Your name (optional)",
  landing_waitlist_email_placeholder: "Enter your email",
  landing_waitlist_submit: "Join Waitlist",
  landing_waitlist_disclaimer: "No spam. We'll only notify you when we launch.",
  landing_waitlist_success_title: "You're in!",
  landing_waitlist_success_subtitle: "Welcome to the waitlist",
  landing_waitlist_success_note: "We'll notify you when we launch.",
  landing_waitlist_error_email_required: "Please enter your email address",
  landing_waitlist_error_email_invalid: "Please enter a valid email address",
  landing_waitlist_error_generic: "Something went wrong. Please try again.",

  // ---- Footer ----
  landing_footer_tagline:
    "No small talk. Just real connections through shared experiences.",
  landing_footer_rights: "© {year} Linqx. All rights reserved.",
  landing_footer_col_company: "Company",
  landing_footer_col_legal: "Legal",
  landing_footer_col_get_app: "Get the App",
  landing_footer_link_about: "About",
  landing_footer_link_features: "Features",
  landing_footer_link_contact: "Contact",
  landing_footer_link_privacy: "Privacy Policy",
  landing_footer_link_terms: "Terms of Service",
  landing_footer_link_eula: "EULA",
  landing_footer_social_x: "X",
  landing_footer_social_instagram: "Instagram",
  landing_footer_social_tiktok: "TikTok",
  landing_footer_social_email: "Email",
  landing_footer_coming_soon: "Coming soon on",
  landing_footer_app_store: "App Store",
  landing_footer_google_play: "Google Play",

  // ---- Legal layout chrome ----
  landing_legal_back_home: "Back to Home",
  landing_legal_last_updated: "Last updated: {date}",
  landing_legal_privacy_title: "Privacy Policy",
  landing_legal_terms_title: "Terms of Use",
  landing_legal_eula_title: "Linqx End User License Agreement (EULA)",
  landing_legal_privacy_updated: "February 1, 2025",
  landing_legal_terms_updated: "February 6, 2025",
  landing_legal_eula_updated: "March 04, 2025",
};
